/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { faCheck, faSearch, faUser, faUserCircle } from '@fortawesome/pro-regular-svg-icons';
import { Subscription } from 'rxjs';
import { TaskStatus } from '../../../../../enums/task-status.enum';
import { EmployeeModel } from '../../../../../models/employee.model';
import { SearchModel } from '../../../../../models/search.model';
import { TaskModel } from '../../../../../models/task.model';
import { EmployeeService } from '../../../../../services/employee.service';
import { TaskService } from '../../../../../services/task.service';

@Component({
  selector: 'app-claim-menu',
  templateUrl: './claim-menu.component.html',
  styleUrls: ['./claim-menu.component.scss'],
  standalone: false
})
export class ClaimMenuComponent implements OnInit, OnDestroy {
  faSearch = faSearch;
  faUser = faUser;
  faCheck = faCheck;
  faUserCircle = faUserCircle;

  TaskStatus = TaskStatus;
  @Input() task!: TaskModel;

  availableEmployees: EmployeeModel[] = [];
  employeeSearchSubscription?: Subscription;

  constructor(
    private employeeService: EmployeeService,
    private taskService: TaskService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    let searchBody: SearchModel = {
      search_criteria: {},
      sort: 'full_name',
      select: '_id full_name user_name',
      skip: 0,
      limit: 0
    };

    if (this.task?.groupedTask) {
      searchBody.search_criteria = {
        employee_group: {
          $in: this.task.assignedTo
        }
      };
    }

    this.employeeSearchSubscription = this.employeeService.employeesSearchChanged.subscribe(
      (employees) => {
        this.availableEmployees = employees;
        this.cdr.detectChanges();
      }
    );

    this.employeeService.searchEmployees(searchBody);
  }

  ngOnDestroy(): void {
    this.employeeSearchSubscription?.unsubscribe();
  }

  getEmployeeShort(empName: string): string {
    if (empName == null) {
      return '';
    } else {
      return empName
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase();
    }
  }
  async releaseTask(taskId: string) {
    await this.taskService.releaseTask(taskId);
    this.taskService.getTask(taskId);
  }

  claimTask(task: TaskModel, employee: EmployeeModel) {
    this.taskService.claimTask(task, employee.employeeId);
  }
}
